import { render, staticRenderFns } from "./blueprint-canvas.vue?vue&type=template&id=4c034586&scoped=true"
import script from "./blueprint-canvas.vue?vue&type=script&lang=js"
export * from "./blueprint-canvas.vue?vue&type=script&lang=js"
import style0 from "./blueprint-canvas.vue?vue&type=style&index=0&id=4c034586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c034586",
  null
  
)

export default component.exports